import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AuthGuard from './components/AuthGuard';
import Login from './pages/Login';
import DataCollection from './pages/DataCollection';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route 
          path="/" 
          element={
            <AuthGuard>
              <DataCollection />
            </AuthGuard>
          } 
        />
      </Routes>
    </Router>
  );
}

export default App;